/**
 * Extracts finance terms by credit tier from dealer settings API response.
 * Creates a mapping of credit tier names to available finance terms. Like so:
 *
 * {
 *   excellent: [36, 48, 60, 72, 84],
 *   verygood: [36, 48, 60, 72],
 *   ...etc.
 * }
 *
 * @param {Object} dealerSettings - The dealer settings API response object
 * @param {number} defaultFinanceTerms - Default finance term from dealer settings
 * @returns {Object|null} Object with credit tier keys and term arrays, or null if no credit tiers
 */
const getFinanceTermsByTier = function () {
  let dealerSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    creditTiers
  } = dealerSettings || {};
  const {
    creditTiers: tiers = []
  } = creditTiers || {};

  // If no credit tiers or empty, return null
  if (tiers?.length === 0) {
    return null;
  }
  const financeTermsByTier = {};
  tiers.forEach(tier => {
    const {
      name,
      aprs = []
    } = tier;
    if (!name) return; // Skip tiers without a name

    // Extract unique terms from APRs and sort them
    const uniqueTermsSet = new Set(aprs.map(apr => apr.term));
    const terms = Array.from(uniqueTermsSet).sort((a, b) => a - b);

    // Use normalized tier name (lowercase, no spaces) as key
    const tierKey = name.replace(/\s/g, '').toLowerCase();
    financeTermsByTier[tierKey] = terms;
  });

  // Return the mapping of finance terms by tier
  return Object.keys(financeTermsByTier).length > 0 ? financeTermsByTier : null;
};
export { getFinanceTermsByTier as default };
